import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import config from "../../config";

const MinimalLayout = () => {
  const location = useLocation();
  const isForgot = location?.pathname?.includes("/forgot-password");

  return (
    <>
      <Helmet>
        <title>Customer Portal | Beauti</title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        />
      </Helmet>
      <main>
        <div
          className="signup-page cp-auth-page"
          style={{ backgroundImage: `url(${config.imagepath}signupimg.png)` }}
        >
          <div className="signup-header bg-white">
            <div className="row align-items-center signup-header-paddings">
              <div className="signup-header-left col-auto">
                <Link to="/login" className="signup-logo">
                  <img src={`${config.imagepath}beautilogo-new.png`} alt="Beauti" />
                </Link>
              </div>
              <div className="signup-header-right col-auto ms-auto">
                {isForgot ? (
                  <p className="already-login">
                    <Link to="/login" className="cursor-pointer">
                      Back to sign in
                    </Link>
                  </p>
                ) : null}
              </div>
            </div>
          </div>
          <Outlet />
        </div>
      </main>
    </>
  );
};

export default MinimalLayout;
